import React from 'react';
/** @type {import('../types').DataType<import('./types').SystemAnalyticsStatusDataModel>} */

var SYSTEM_ANALYTICS_STATUS_DATA_TYPE = {
  data: {
    itemUrl: '/backend/systemanalytics/status',
    dataKey: 'systemAnalyticsStatus',
    idKeyProp: null
  }
};
export default SYSTEM_ANALYTICS_STATUS_DATA_TYPE;